import {CSSProperties, FC} from 'react';


export interface IIconPhoneProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconPhone: FC<IIconPhoneProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M9.659 10.828a9.381 9.381 0 0 0 3.513 3.513l.785-1.1a.889.889 0 0 1 1.15-.263c1.258.687 2.646 1.1 4.074 1.212a.889.889 0 0 1 .819.886v3.967a.889.889 0 0 1-.798.884c-.471.049-.946.073-1.424.073C10.168 20 4 13.831 4 6.222c0-.478.024-.953.073-1.424A.889.889 0 0 1 4.957 4h3.967c.463 0 .85.356.886.819a10.154 10.154 0 0 0 1.212 4.073.889.889 0 0 1-.263 1.15l-1.1.786Zm-2.242-.584 1.689-1.206a11.92 11.92 0 0 1-.975-3.26H5.787a12.3 12.3 0 0 0-.008.444c-.001 6.628 5.371 12 11.999 12 .148 0 .297-.002.444-.009V15.87a11.92 11.92 0 0 1-3.26-.975l-1.206 1.69a11.054 11.054 0 0 1-1.412-.668l-.052-.029a11.162 11.162 0 0 1-4.18-4.18l-.028-.051a11.054 11.054 0 0 1-.667-1.412Z" clipRule="evenodd" />
        </svg>
    );
};
